import {Injectable} from '@angular/core';
import {TestService} from '@ispm/dashboard/test/services/test.service';
import {AuthenticationService} from '@ispm/user/services/authentication.service';

@Injectable()
export class SpecimensAndSamplesService {

  constructor(private authService: AuthenticationService, private testService: TestService) {
  }
}


